import { observable, action, computed } from 'mobx';
import { setter } from 'mobx-decorators';

class TeamUsersCheckboxListStore {

    @observable selectableList = [];

    @computed get selectedTeamUsers() {

        const teams = this.selectableList.filter((team) => {

            return team.selected == true;
        });

        return teams.length > 0 ? ` (${teams.length})` : '';
    }
    
    @action buildCheckboxList(sourceList, existingMembers) {
        
        let newList = [];

        sourceList.forEach((item) => {
            
            const existingMember = existingMembers.find((member) => member.id == item.id);
            
            if (existingMember) {
                return;
            }

            const selectableItem = {
                id: item.id,
                selected: false,
                visible: true,
                itemData: item
            };
            
            newList.push(selectableItem);
        });

        this.selectableList = newList;
    }

    @action resetSelectableList() {

        this.setSelectableList([]);
    }

    @action setSelectableList(list) {

        this.selectableList = list;
    }
}

export default new TeamUsersCheckboxListStore();